require("datatables.net");
require("datatables.net-bs4");
require("datatables.net-responsive");
require("datatables.net-responsive-bs4");
require("datatables.net-select");
require("datatables.net-select-bs4");
require("jquery-datatables-checkboxes");

var moment = require('moment');

$(document).ready(function(){

    let locale = '';
    switch(window._locale){
        case 'en':
            locale = 'en-GB';
        break;
        default: 
            locale = 'es-ES';
    }

    moment.locale(locale);

    $.extend(true, $.fn.dataTable.defaults, {
        searchDelay: 500,
        processing: true,
        serverSide: true,
        stateSave: true,
        responsive: true,
        deferRender: true,
        ajax: {
            data: function(data, settings){

                $(settings.nTableWrapper)
                    .find('.filters-container .table_filters input, .filters-container .table_filters select')
                    .each(function(){
                        if(typeof($(this).attr('name') != 'undefined') && typeof($(this).val()) != 'undefined'){
                            data[$(this).attr('name')] = $(this).val();
                        }
                    });

            },
        },
        pagingType: 'simple_numbers',
        dom: "<'row'<'col-sm-12 d-flex flex-column flex-sm-row justify-content-between align-items-center filters-container'l<'filters'f>>><'row'<'col-sm-12'tr>><'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7'p>>",
        initComplete: function(settings){

            $(settings.nTableWrapper).find('.dataTables_length select').select2({
                minimumResultsForSearch: -1,
            });

            $(settings.nTableWrapper).css('display', 'block');
            $(settings.nTableWrapper).find('.table').css('visibility', 'visible');
            
            // comentado porque hace que el la tabla se cargue dos veces
            // en caso de ser necesario habría que ejecutarlo con el evento
            // que desencadena la visualización, por ejemplo, un cambio de tab
            // $(settings.nTable).dataTable().fnAdjustColumnSizing();

            // init filters

            const table_id = $(settings.nTable).attr('id');

            const filters = $(settings.nTableWrapper).siblings('.table_filters').detach();
            $(settings.nTableWrapper).find('.filters-container .filters').prepend(filters);

            $(settings.nTableWrapper).find('.filters-container .filters select')
                .select2('destroy')
                .select2({ 
                    minimumResultsForSearch: 10 
                })
                .change(function(){
                    $(this).closest('.dataTables_wrapper').find('.dataTable').DataTable().ajax.reload();
                });

            // $(settings.nTable).DataTable().ajax.reload();

            // init batch actions

            const batch = $(settings.nTableWrapper).siblings('.table_batch').detach();
            $(settings.nTableWrapper).find('.dataTables_info').parent().prepend(batch);

            settings.oLanguage.select.rows = {
                0: window.__('Ninguna fila seleccionada'),
                1: window.__('1 fila seleccionada') + ' <a onclick="window.datatables.clear_selection(event)">' + window.__('limpiar selección') + '</a>',
                _: window.__('%d filas seleccionadas') + ' <a onclick="window.datatables.clear_selection(event)">' + window.__('limpiar selección') + '</a>',
            }

        },
        drawCallback: function(settings){

            /* 
            ** habilita la ejecución de la acción predeterminada (botón con clases .btn y .show) al pulsar sobre cualquier celda de la fila
            ** entra en conflicto con las tablas responsive ya que al pulsar sobre la fila se despliegan los campos que no se muestran
            **
            $('.dataTable tbody td:not(.init)').each(function(){

                if(
                    $(this).find('button, a').length == 0 
                    && $(this).closest('tr').find('.btn.show').length == 1
                ){

                    $(this).click(function(){
                        $(this).closest('tr').find('.btn.show').trigger('click');
                    });

                    $(this).addClass('pointer');    

                }

                $(this).addClass('init');

            });
            */
            
            window.ajax.init_links();
            window.ajax.init_forms();

            $(settings.nTable).find('.btn').click(function(event){
                event.stopPropagation();
            });

        },
        language: {
            url: window._url + '/assets/dt-i18n/' + locale + '.json'
        }
    });

    $.extend(true, $.fn.dataTable.ext.classes, {
        sLengthSelect: "form-control",
    });

    $.extend(true, $.fn.dataTable.ext.pager, {
        numbers_length: 5,
    });

});

export function clear_selection(ev){

    $(ev.target)
        .closest('.dataTables_wrapper')
        .find('.dataTable')
        .DataTable()
        .column(0)
        .checkboxes
        .deselectAll();

}

export function render_date(data, type, row){

    if(data == null){
        return '';
    }

    var fecha = moment(data);
    return fecha.format('DD/MM/YY');

}

export function render_time(data, type, row){

    if(data == null){
        return '';
    }

    var fecha = moment(data);
    return fecha.format('HH:mm');

}

export function render_datetime(data, type, row){

    if(data == null){
        return '';
    }

    var fecha = moment(data);
    return fecha.format('DD/MM/YY HH:mm');

}

export function render_datetime_seconds(data, type, row){

    if(data == null){
        return '';
    }

    var fecha = moment(data);
    return fecha.format('DD/MM/YY HH:mm:ss');

}

export function render_array(data, type, row){

    if(data == null){
        return '';
    }
    
    var json = JSON.stringify(data, null, 2)
        .replace(/"/gi, '')
        .replace(/^[\[\{][\]\}]$/gi, '')
        .replace(/^[\{\[]\n/gi, '')
        .replace(/\n[\}\]]$/gi, '');

    return render_multiline(json, type, row);

}

export function render_multiline(data, type, row){

    if(data == null){
        return '';
    }

    return data.replace(/\n/gi, '&nbsp;<br/>');

}

export function render_small(data, type, row){

    if(data == null){
        return '';
    }

    return data.replace(/(\(.*\))/ig, "<small>$1</small>");

}

export function render_small_newline(data, type, row){

    if(data == null){
        return '';
    }

    return render_multiline(
        data.replace(/(\(.*\))/ig, "<small class=\"d-block\">$1</small>"), 
        type, 
        row
    );

}